import { Card, CardBody, Col } from 'reactstrap';

import Breadcrumbs from '../../CommonElements/Breadcrumbs';
import CommonCardHeader from '../../Utils/CommonComponents/CommonCardHeader';
import useAuth from '../../Hooks/useAuth';
import { CustomTable } from '../../components/common/Table/CustomTable';
import { InvestmentMapper } from '../../infrastructure/mappers/investment.mapper';
import { TableHeader } from '../../components/common/Table/TableHeader';
import { tableColumnsInvestment } from './Components/TableColumns';

export const Investment = () => {
   const { user } = useAuth();

   const handleDropdownClick = async (item: string) => {};

   return (
      <div className="page-body">
         <Breadcrumbs
            pageTitle="Inversiones"
            parent="Sociedad"
            title="Inversiones"
         />
         <Col sm={12}>
            <Card>
               <CommonCardHeader
                  title="Listado de Inversiones"
                  subTitle={[
                     {
                        text: 'Consulta y administra tus inversiones de manera eficiente. Este listado te proporciona un resumen detallado de tus aportes, rentabilidad y estado actual, permitiéndote tomar decisiones estratégicas para optimizar tu capital.',
                     },
                  ]}
               />

               <CardBody>
                  <TableHeader
                     dropDownList={['Nuevo']}
                     onItemClick={handleDropdownClick}
                  />
                  <div className="table-responsive">
                     <CustomTable
                        route={`investments/${user?.id}`}
                        columns={tableColumnsInvestment}
                        mapper={InvestmentMapper.mapResponseToInvestment}
                     />
                  </div>
               </CardBody>
            </Card>
         </Col>
      </div>
   );
};

export default Investment;
